import './Grid.css'
import { motion, Variants } from "framer-motion"

const draw: Variants = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: (i: number) => {
    const delay = 0.25 + i * 0.25
    return {
      pathLength: 1,
      opacity: 0.3,
      transition: {
        pathLength: { delay, type: "spring", duration: 1.5, bounce: 0 },
        opacity: { delay, duration: 0.01 }
      }
    }
  }
}

export default function Grid(): JSX.Element {
  return (
      <motion.svg
      width="2000"
      height="2000"
      viewBox="0 0 1400 1400"
      initial="hidden"
      animate="visible"
      className="svg"
      aria-hidden="true"
      role="presentation"
      focusable="false"
    >
      <motion.line
        x1="-200"
        y1="100"
        x2="1400"
        y2="100"
        stroke="#ffc0cb"
        custom={1}
        variants={draw}
      />
      <motion.line
        x1="-180"
        y1="200"
        x2="1450"
        y2="200"
        stroke="#ffc0cb"
        custom={1.25}
        variants={draw}
      />
      <motion.line
        x1="-160"
        y1="300"
        x2="1500"
        y2="300"
        stroke="#ffc0cb"
        variants={draw}
        custom={1.5}
      />
      <motion.line
        x1="-140"
        y1="400"
        x2="1550"
        y2="400"
        stroke="#ffc0cb"
        variants={draw}
        custom={1.75}
      />
      <motion.line
        x1="-120"
        y1="500"
        x2="1600"
        y2="500"
        stroke="#ffc0cb"
        variants={draw}
        custom={2}
      />
      <motion.line
        x1="-100"
        y1="600"
        x2="1640"
        y2="600"
        stroke="#ffc0cb"
        custom={2.25}
        variants={draw}
      />
      <motion.line
        x1="-80"
        y1="700"
        x2="1680"
        y2="700"
        stroke="#ffc0cb"
        custom={2.5}
        variants={draw}
      />
      <motion.line
        x1="-60"
        y1="800"
        x2="1720"
        y2="800"
        stroke="#ffc0cb"
        custom={2.75}
        variants={draw}
      />
      <motion.line
        x1="-40"
        y1="900"
        x2="1760"
        y2="900"
        stroke="#ffc0cb"
        custom={3}
        variants={draw}
      />
      <motion.line
        x1="-20"
        y1="1000"
        x2="1800"
        y2="1000"
        stroke="#ffc0cb"
        custom={3.25}
        variants={draw}
      />
      <motion.line
        x1="0"
        y1="1100"
        x2="1840"
        y2="1100"
        stroke="#ffc0cb"
        custom={3.5}
        variants={draw}
      />
      <motion.line
        x1="20"
        y1="1200"
        x2="1880"
        y2="1200"
        stroke="#ffc0cb"
        custom={3.75}
        variants={draw}
      />
      <motion.line
        x1="40"
        y1="1300"
        x2="1920"
        y2="1300"
        stroke="#ffc0cb"
        custom={4}
        variants={draw}
      />
      <motion.line
        x1="-200"
        y1="0"
        x2="300"
        y2="1400"
        stroke="#ffc0cb"
        custom={1}
        variants={draw}
      />
      <motion.line
        x1="-100"
        y1="0"
        x2="400"
        y2="1400"
        stroke="#ffc0cb"
        custom={1.25}
        variants={draw}
      />
      <motion.line
        x1="0"
        y1="0"
        x2="500"
        y2="1400"
        stroke="#ffc0cb"
        custom={1.5}
        variants={draw}
      />
      <motion.line
        x1="100"
        y1="0"
        x2="600"
        y2="1400"
        stroke="#ffc0cb"
        custom={1.75}
        variants={draw}
      />
      <motion.line
        x1="200"
        y1="0"
        x2="700"
        y2="1400"
        stroke="#ffc0cb"
        custom={2}
        variants={draw}
      />
      <motion.line
        x1="300"
        y1="0"
        x2="800"
        y2="1400"
        stroke="#ffc0cb"
        custom={2.25}
        variants={draw}
      />
      <motion.line
        x1="400"
        y1="0"
        x2="900"
        y2="1400"
        stroke="#ffc0cb"
        custom={2.5}
        variants={draw}
      />
      <motion.line
        x1="500"
        y1="0"
        x2="1000"
        y2="1400"
        stroke="#ffc0cb"
        custom={2.75}
        variants={draw}
      />
      <motion.line
        x1="600"
        y1="0"
        x2="1100"
        y2="1400"
        stroke="#ffc0cb"
        custom={3}
        variants={draw}
      />
      <motion.line
        x1="700"
        y1="0"
        x2="1200"
        y2="1400"
        stroke="#ffc0cb"
        custom={3.25}
        variants={draw}
      />
      <motion.line
        x1="800"
        y1="0"
        x2="1300"
        y2="1400"
        stroke="#ffc0cb"
        custom={3.5}
        variants={draw}
      />
      <motion.line
        x1="900"
        y1="0"
        x2="1400"
        y2="1400"
        stroke="#ffc0cb"
        custom={3.75}
        variants={draw}
      />
      <motion.line
        x1="1000"
        y1="0"
        x2="1500"
        y2="1400"
        stroke="#ffc0cb"
        custom={4}
        variants={draw}
      />
      <motion.line
        x1="1100"
        y1="0"
        x2="1600"
        y2="1400"
        stroke="#ffc0cb"
        custom={4.25}
        variants={draw}
      />
      <motion.line
        x1="1200"
        y1="0"
        x2="1700"
        y2="1400"
        stroke="#ffc0cb"
        custom={4.5}
        variants={draw}
      />
      <motion.line
        x1="1300"
        y1="0"
        x2="1800"
        y2="1400"
        stroke="#ffc0cb"
        custom={4.75}
        variants={draw}
      />
    </motion.svg>
  )
}
